import { useState } from 'react';
import styled from 'styled-components';
import { ItemStatusList } from '../../../../interface/aiAnalyze/aiRecommend/data';
import BottomModal from '../../../components/modal/BottomModal';
import {
  CancleButton,
  ConfirmButton,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '../../../components/modal/Modal.style';
import { Section } from './SelectModal.styles';

interface ItemListModalProps {
  category: string;
  selected: string;
  onApply: (selected: string) => void;
  onClose: () => void;
}

const ItemListModal = ({
  category,
  selected,
  onApply,
  onClose,
}: ItemListModalProps) => {
  const [selectedItem, setSelectedItem] = useState(selected);

  const options =
    ItemStatusList.find((item) => item.label === category)?.options || [];

  const toggleItem = (item: string) => {
    setSelectedItem((prev) => (prev === item ? '' : item)); // 단일 선택
  };

  const handleApply = () => {
    onApply(selectedItem);
    onClose();
  };

  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>물건 종류</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <ModalInner>
        <Section $gap={8}>
          <Category>{category}</Category>
          {options.map((option) => (
            <CheckButtonLabel>
              <input
                type="checkbox"
                checked={selectedItem === option.value}
                onChange={() => toggleItem(option.value)}
              />
              <img
                src={
                  selectedItem === option.value
                    ? '/assets/images/icon/algo-cicle-icon-on.svg'
                    : '/assets/images/icon/algo-cicle-icon-off.svg'
                }
                alt={option.label}
              />
              {option.label}
            </CheckButtonLabel>
          ))}
        </Section>
      </ModalInner>
      <ModalFooter>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton $disabled={selectedItem === ''} onClick={handleApply}>
          적용
        </ConfirmButton>
      </ModalFooter>
    </BottomModal>
  );
};

export default ItemListModal;

const Category = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const CheckButtonLabel = styled.label`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  input {
    display: none;
  }
`;

const ModalInner = styled.div`
  height: 100%;
  overflow-y: auto;
`;
